import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { useIntl } from "react-intl";
import { links } from "src/app/types/orders/order";
import { UserRole } from "src/app/transports/user";
import { CheckRoles } from "src/app/utils/CheckRoles";

export function useOrderStatusGridColumns(role: UserRole): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();
    const isProjectManager = CheckRoles.isLeadProjectManagerOrUnder(role);

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: isProjectManager ? "moneySite.domain" : "platform.name",
            headerName: formatMessage({
                id: `content.grid.col.${isProjectManager ? "moneySite" : "platform"}`,
            }),
            pinned: "left",
            width: 120,
        },
        {
            field: "rd.domain",
            headerName: formatMessage({ id: "content.grid.col.rd" }),
            width: 130,
        },
        {
            field: "links",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.links" }),
            valueGetter: ({ data }: any) =>
                data?.links
                    ? data.links[1]
                        ? `${data.links[0].url} (${data.links[0].anchor})\n ${data.links[1].url} (${data.links[1].anchor})`
                        : `${data.links[0].url} (${data.links[0].anchor})`
                    : "",

            cellRenderer: ({ data }: any) => (
                <ul className="padding-start-0 mb-0">
                    {data?.links?.map((link: links, index: number) => (
                        <li key={index} style={{ listStyleType: "none" }}>
                            {link.url} ({link.anchor})
                        </li>
                    ))}
                </ul>
            ),
        },
        {
            field: "status",
            headerName: formatMessage({ id: "content.grid.col.status" }),
            valueGetter: ({ data }: any) => {
                if (!data.deliveredAt) return `${formatMessage({ id: "write.title" })}`;
                if (!data.reviewedAt && data.reviewNeeded)
                    return `${formatMessage({ id: "proofread.title" })}`;
                if (data.approveNeeded && !data.isApproved)
                    return `${formatMessage({ id: "approve.title" })}`;
                if (!data.url) return `${formatMessage({ id: "publish.title" })}`;
            },
            width: 80,
        },
    ];

    return gridColumns;
}
